export default {
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    changeIdentificationFun(e) {
      this.form.isIdentification = e.target.checked;
      this.changeFun();
    },
    imgClick(val) {
      this.form.controlsComponentsMark = val;
      this.changeFun();
    }
  }
};